module.exports = __webpack_public_path__ + "img/pointer.599a107d.png";